"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonDetailsBanner = exports.LessonDetailsBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_details_banner_1 = require("./entity-details-banner");
var ui_1 = require("@shapeable/ui");
var icons_1 = require("@shapeable/icons");
var use_lang_1 = require("../../hooks/use-lang");
var icon_label_1 = require("../elements/icon-label");
exports.LessonDetailsBannerDefaultProps = {
  buttonColors: {
    text: 'text',
    border: 'text',
    fill: 'text',
    hover: {
      text: 'text-mid',
      border: 'text-mid',
      fill: 'text-mid'
    }
  }
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(8))
});
var LinkButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n    max-width: 300px;\n  "], ["\n    margin-top: ", ";\n    max-width: 300px;\n  "])), theme_1.theme.UNIT(3))
});
var IconLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-top: ", ";\n  "], ["\n    padding-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(entity_details_banner_1.EntityDetailsBanner)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LinkButton: (0, styled_components_1.default)(ui_1.Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles)
};
var LessonDetailsBanner = function (props) {
  var className = props.className,
    entity = props.entity,
    buttonColors = props.buttonColors;
  var t = (0, use_lang_1.useLang)();
  var url = entity.url,
    hours = entity.hours;
  var linkToExternalModuleButtonOnClick = function () {
    if (!url) return;
    window.open(url, '_blank');
  };
  return react_1.default.createElement(My.Container, {
    entity: entity,
    size: "large",
    entityTypeName: "Lesson",
    showSlug: false,
    showFollowControls: false,
    alwaysShowFollowControls: true
  }, !!hours && react_1.default.createElement(My.IconLabel, {
    icon: react_1.default.createElement(icons_1.UnitIcon, null)
  }, t("".concat(hours, " hour module"))), !!url && react_1.default.createElement(My.LinkButton, {
    onClick: linkToExternalModuleButtonOnClick,
    colors: buttonColors,
    shape: 'rounded',
    borderStyle: 'dotted',
    icon: icons_1.ExternalLinkIconGlyph
  }, t(process.env.MODULE_URL_LINK_LABEL || 'Link To External Module')));
};
exports.LessonDetailsBanner = LessonDetailsBanner;
exports.LessonDetailsBanner.defaultProps = exports.LessonDetailsBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;